import { render, staticRenderFns } from "./ColorListingProduct.vue?vue&type=template&id=7408f699&scoped=true"
import script from "./ColorListingProduct.vue?vue&type=script&lang=js"
export * from "./ColorListingProduct.vue?vue&type=script&lang=js"
import style0 from "./ColorListingProduct.vue?vue&type=style&index=0&id=7408f699&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7408f699",
  null
  
)

export default component.exports